import '../Top.css';
import { FC, ReactElement, useEffect, useRef, useState } from "react";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import { PromptHintSet } from "../model/PromptHintSet";
import { PromptHint } from "../model/PromptHint";
import { Helmet } from "react-helmet";
import { Modal } from "@mantine/core";
import { LoginDialog } from "../parts/LoginDialog";
import { useDisclosure } from "@mantine/hooks";
import { useLocation } from 'react-router-dom';
export const TopPage: FC = () => {
const [loginDialogOpened, { open: openLoginDialog, close: closeLoginDialog }] = useDisclosure(false);
  
  function onLogin(){
    window.location.href = "/image-generation";
  }

  const ScrollToHashElement = () => {
    const { hash } = useLocation();

    useEffect(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }
    }, [hash]);

    return null;
  };

  return <>
  <ScrollToHashElement />
  <Helmet>
    <script src="/lp/assets/js/jquery-3.7.1.min.js" type="text/javascript" />
    <script src="/lp/assets/js/script.js" type="text/javascript" />
    <title>無料で使えるAI画像生成ツール - Drop AI</title>
    <meta name="description" content="無料のAI画像生成ツール Drop AI（ドロップAI）であなたのクリエイティビティを具現化。お気に入りのモデルとプロンプトを選ぶだけで高品質なAI画像を生成できる。" />
    <meta property="og:url" content="https://drop4i.com/" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="無料で使えるAI画像生成ツール - Drop AI" />
    <meta property="og:description" content="無料のAI画像生成ツール Drop AI（ドロップAI）であなたのクリエイティビティを具現化。お気に入りのモデルとプロンプトを選ぶだけで高品質なAI画像を生成できる。" />
  </Helmet>
  <Modal size="auto" opened={loginDialogOpened} onClose={closeLoginDialog}>
    <LoginDialog onCancel={() => closeLoginDialog()} onLogin={() => onLogin()} isLogin={true} />
  </Modal>
  
  <main>
    <section className="mv">
      <div className="mv__wrapper">
        <div className="mv__text-wrapper">
          <h1 className="mv__main-copy anime-fadeUp">
            <span>プロンプトを選ぶだけ。</span>
            <br />
            高品質な
            <br />
            画像生成AIの世界へ。
          </h1>
          <p className="mv__desc anime-fadeIn">
            <span>プロンプト入力に悩まずアイデアを表現できる、</span>
            <span>クリエイターのための画像生成サービス</span>
          </p>
          <a
            href="/image-generation"
            className="btn _shine _arrow anime-fadeIn"
          >
            <span className="font-bold">画像生成をはじめる</span>
          </a>
        </div>
        <ul className="mv__img-list anime-fadeIn-list-img">
          <li className="mv__img-item">
            <img
              src="/lp/assets/img/mv_img01.png"
              alt=""
              width={503}
              height={340}
            />
            <img
              src="/lp/assets/img/mv_img02.png"
              alt=""
              width={505}
              height={506}
            />
            <img
              src="/lp/assets/img/mv_img03.png"
              alt=""
              width={506}
              height={653}
            />
            <img
              src="/lp/assets/img/mv_img04.png"
              alt=""
              width={506}
              height={678}
            />
          </li>
          <li className="mv__img-item">
            <img
              src="/lp/assets/img/mv_img06.png"
              alt=""
              width={507}
              height={403}
            />
            <img
              src="/lp/assets/img/mv_img05.png"
              alt=""
              width={506}
              height={610}
            />
            <img
              src="/lp/assets/img/mv_img08.png"
              alt=""
              width={504}
              height={339}
            />
            <img
              src="/lp/assets/img/mv_img07.png"
              alt=""
              width={506}
              height={599}
            />
            <img
              src="/lp/assets/img/mv_img09.png"
              alt=""
              width={506}
              height={213}
            />
          </li>
          <li className="mv__img-item">
            <img
              src="/lp/assets/img/mv_img11.png"
              alt=""
              width={506}
              height={548}
            />
            <img
              src="/lp/assets/img/mv_img10.png"
              alt=""
              width={505}
              height={506}
            />
            <img
              src="/lp/assets/img/mv_img12.png"
              alt=""
              width={505}
              height={383}
            />
            <img
              src="/lp/assets/img/mv_img13.png"
              alt=""
              width={506}
              height={743}
            />
          </li>
        </ul>
      </div>
      <div id="js-fixedBtnShowTarget" className="mv__sp-img anime-fadeUp">
        <img
          src="/lp/assets/img/mv_sp-img.png"
          alt=""
          width={946}
          height={1920}
        />
      </div>
    </section>
    <section id="service" className="section service">
      <h2 className="heading-medium">
        写真も、イラストも、
        <br className="disp-sm" />
        人物も、風景も
        <br />
        アイデアをあっという間に表現
      </h2>
      <ul className="service__img-list anime-fadeIn-list-img">
        <li className="service__img-item">
          <img
            src="/lp/assets/img/img_service01.png"
            alt=""
            width={747}
            height={481}
          />
          <img
            src="/lp/assets/img/img_service02.png"
            alt=""
            width={747}
            height={714}
          />
          <img
            src="/lp/assets/img/img_service03.png"
            alt=""
            width={747}
            height={924}
          />
        </li>
        <li className="service__img-item">
          <img
            src="/lp/assets/img/img_service04.png"
            alt=""
            width={748}
            height={949}
          />
          <img
            src="/lp/assets/img/img_service05.png"
            alt=""
            width={747}
            height={457}
          />
          <img
            src="/lp/assets/img/img_service06.png"
            alt=""
            width={741}
            height={711}
          />
        </li>
        <li className="service__img-item">
          <img
            src="/lp/assets/img/img_service07.png"
            alt=""
            width={749}
            height={539}
          />
          <img
            src="/lp/assets/img/img_service08.png"
            alt=""
            width={742}
            height={918}
          />
          <img
            src="/lp/assets/img/img_service09.png"
            alt=""
            width={742}
            height={655}
          />
        </li>
        <li className="service__img-item">
          <img
            src="/lp/assets/img/img_service10.png"
            alt=""
            width={748}
            height={762}
          />
          <img
            src="/lp/assets/img/img_service11.png"
            alt=""
            width={747}
            height={653}
          />
          <img
            src="/lp/assets/img/img_service12.png"
            alt=""
            width={742}
            height={703}
          />
        </li>
        <li className="service__img-item">
          <img
            src="/lp/assets/img/img_service13.png"
            alt=""
            width={747}
            height={950}
          />
          <img
            src="/lp/assets/img/img_service14.png"
            alt=""
            width={742}
            height={574}
          />
          <img
            src="/lp/assets/img/img_service15.png"
            alt=""
            width={742}
            height={587}
          />
        </li>
      </ul>
      <a href="/inspiration" className="btn _white _arrow">
        生成画像を見る
      </a>
    </section>
    <section id="howtouse" className="section howtouse">
      <div className="container">
        <div className="howtouse__wrapper">
          <div className="howtouse__text-wrapper">
            <h2 className="heading-large anime-fadeUp">
              テイストに合わせて
              <br />
              プロンプトを<span>選ぶだけ</span>
              <br />
              高品質なAI画像を生成
            </h2>
          </div>
          <div className="howtouse__img-wrapper">
            <div className="howtouse__img-main">
              <img
                src="/lp/assets/img/img_howtouse_sample.png"
                alt=""
                width={1080}
                height={1080}
              />
            </div>
            <div className="howtouse__img-prompt">
              <img
                src="/lp/assets/img/img_howtouse_prompt.svg"
                alt=""
                width={1920}
                height={1080}
              />
            </div>
          </div>
        </div>
        <p className="howtouse__annotation">※プロンプト入力も可能です</p>
      </div>
    </section>
    <section id="about" className="section about">
      <div className="container">
        <h2 className="heading-large">Drop AIとは</h2>
        <div className="about__wrapper">
          <ul className="about__list anime-fadeUp-list-item">
            <li className="about__item">
              <span>Stable Diffusion</span>をベースにしたAI画像生成サービス
            </li>
            <li className="about__item">
              テイストや目的に合わせたモデルを選べるから
              <span>外し生成が少ない</span>
            </li>
            <li className="about__item">
              <span>プロンプト知識の有無に関わらず</span>簡単に画像生成ができる
            </li>
          </ul>
          <div className="about__img">
            <img
              src="/lp/assets/img/img_about_mock.png"
              alt=""
              width={1280}
              height={720}
            />
          </div>
        </div>
      </div>
    </section>
    <section id="price" className="section price">
      <div className="container">
        <div className="price__wrapper">
          <h2 className="heading-large">
            無料で
            <br />
            すぐに使えます。
          </h2>
          <div className="price__box anime-fadeUp">
            <p className="price__box-free">Free</p>
            <p className="price__box-price">
              <span>¥</span>0
            </p>
            <ul className="price__box-list">
              <li>1日あたりの生成数の上限 4まで</li>
              <li>広告非表示オプション なし</li>
              <li>同時画像生成 1まで</li>
              <li>生成画像の保存期間 30日間</li>
              <li>詳細画像設定機能 なし</li>
            </ul>
          </div>
          <a href="/image-generation" className="btn _shine _arrow">
            <span className="font-bold">画像生成をはじめる</span>
          </a>
          <p className="price__desc">
            制限を気にせず使い倒したい方には有料プランがあります。
            <br className="disp-lg" />
            <a href="/plan">プラン一覧を見る</a>
          </p>
        </div>
      </div>
    </section>
    <section id="faq" className="section faq">
      <div className="container _narrow">
        <h2 className="heading-medium">よくある質問</h2>
        <div className="faq__wrapper">
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                画像生成AIとは何ですか？
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              テキストや画像などの指示をもとに、独自の画像を生成する人工知能（AI）モデルです。
            </dd>
          </dl>
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                Drop AIどのようなサービスですか？
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              Drop AIは画像生成モデルStable
              Diffusionをベースにした画像生成サービスです。プロンプト選択やプロンプトの入力によってかんたんに画像生成が可能となります。
            </dd>
          </dl>
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                無料プランと有料プランの違いは何ですか？
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              無料プランは、一部機能制限がありますが、費用を支払わずに画像生成ができます。有料プランでは、生成制限の緩和や利用機能制限のUnlockなど無料と比較して利用上のメリットが増えます。詳しくは料金プランを参照ください。
            </dd>
          </dl>
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                有料プランの解約はすぐにできますか？解約方法を教えてください。
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              有料プランの解約はサブスクリプションページから可能です。有料プラン解約により、自動更新が停止され、Freeプランにダウングレードされますが、契約期間内は有料プランの内容について引き続き利用が可能です。
            </dd>
          </dl>
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                有料プランの支払い方法を教えてください
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              有料プランの支払い方法はクレジットカード決済（VISA、MASTER、America
              Express）となります。
            </dd>
          </dl>
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                Drop AIの画像生成は安全ですか？
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              Drop
              AIの画像生成は、性的または暴力的な画像生成を最小限にするため、NSFW（Not
              safe for
              work）判定を実施しております。生成画像がNSFW判定に引っかかった場合は当該画像の閲覧はできません（NSFW判定に引っかかった場合は画像生成クレジットは消化されません）
            </dd>
          </dl>
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                Drop 生成画像の商用利用は可能ですか？
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              Drop
              AIは生成画像の商用利用が可能なモデルを利用しています。生成画像が人に危害を加える内容、誤った情報、公序良俗に反する内容、法律に違反する内容でない限りは生成画像は自由に使用できます。
            </dd>
          </dl>
          <dl className="faq__item">
            <dt className="faq__question js-accordion-trigger">
              <button type="button">
                生成画像の著作権について教えてください。
                <span />
              </button>
            </dt>
            <dd className="faq__answer">
              Drop AIのベースである Stable
              Diffusionで作成した画像には著作権が存在しません。
            </dd>
          </dl>
        </div>
      </div>
    </section>
    <div id="js-fixedCtaBtn" className="fixed-btn">
      <a href="/image-generation" className="btn _arrow _shine">
        <span className='font-bold'>画像生成をはじめる</span>
      </a>
    </div>
  </main>
</>;
}